jQuery ->
  $('input[name="users_csv_file"]').on 'change', ->
    filename = $(this).val().split('\\').pop()
    $('#file-chosen').text(filename)
